import { AuthProductName, ViewName } from '@/types'

const movementDecorations = {
  id: 'movement',
  name: 'Movement',
  viewDecorations: [
    {
      badgeText: '',
      viewName: ViewName.Login,
      offerMessage: '',
      title: 'Log in to your account',
      body: 'Enter the email address associated with your account.'
    },
    {
      badgeText: '',
      viewName: ViewName.Success,
      offerMessage: '',
      title: "You're logged in!",
      body: 'Now open Movement.'
    }
  ],
  authProductName: AuthProductName.WEBSITE
}
export default movementDecorations
